// export const years: FilterYear[] = [
//   '2020',
//   '2021',
//   '2022',
//   '2023',
//   '2024',
//   '2025',
//   '2026',
// ];

// export const months: FilterMonth[] = [
//   'January',
//   'February',
//   'March',
//   'April',
//   'May',
//   'June',
//   'July',
//   'August',
//   'September',
//   'October',
//   'November',
//   'December',
// ];

/**
 * Builds a URL query string from an object, filtering out undefined, null, and empty string values
 * @param params - Object containing query parameters
 * @returns URL-encoded query string
 */
export const buildQueryString = (params: object): string => {
  return new URLSearchParams(
    Object.entries(params).reduce(
      (acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          acc[key] = String(value);
        }
        return acc;
      },
      {} as Record<string, string>
    )
  ).toString();
};

// Utility function to slugify a string (e.g., for generating URL-friendly strings)
export const slugify = (text: string): string =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const wait = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Calls `fn` until it resolves, waiting `delayMs` between attempts.
 * Throws the last error if all attempts fail.
 */
export const withRetry = async <T>(
  fn: () => Promise<T>,
  { attempts = 3, delayMs = 700 }: { attempts?: number; delayMs?: number } = {}
): Promise<T> => {
  let lastError: unknown;
  for (let attempt = 1; attempt <= attempts; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (attempt < attempts) await wait(delayMs);
    }
  }
  throw lastError;
};
